export const SET_APP_INITIALISED = 'SET_APP_INITIALISED';
export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_APP_LOADED = 'SET_APP_LOADED';


export function setAppInitialized() {
    return {
        type: SET_APP_INITIALISED,
    }
}

export function setAppLoadingPromise() {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( setAppLoading() );
            resolve()
        })
    }
}

export function setAppLoading() {
    return {
        type: SET_APP_LOADING,
    }
}


export function setAppLoadedPromise() {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( setAppLoaded() );
            resolve()
        })
    }
}

export function setAppLoaded() {
    return {
        type: SET_APP_LOADED,
    }
}
